export default __webpack_public_path__ + "static/media/team-popup.7a8890e3.png";